__turbopack_context__.v({
  "body": "_9Kc9eq_body",
  "controls": "_9Kc9eq_controls",
  "counter": "_9Kc9eq_counter",
  "header": "_9Kc9eq_header",
  "headerTitle": "_9Kc9eq_headerTitle",
  "iframe": "_9Kc9eq_iframe",
  "mediaImg": "_9Kc9eq_mediaImg",
  "overlay": "_9Kc9eq_overlay",
  "panel": "_9Kc9eq_panel",
  "playIcon": "_9Kc9eq_playIcon",
  "playThumb": "_9Kc9eq_playThumb",
  "popupsection-panel-in": "_9Kc9eq_popupsection-panel-in",
  "popupsection-scrim-in": "_9Kc9eq_popupsection-scrim-in",
  "slide": "_9Kc9eq_slide",
  "track": "_9Kc9eq_track",
});
